// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7jXxS","selected":"styles_selected__1xEZT"};